/**
 * Chips of the empty store (plan §5.16): tapping one creates that category
 * right away, named in the admin's language (`menuPage.starter.{key}`).
 * «Otra…» opens the category editor instead.
 */
export type TStarterCategory =
  | 'starters'
  | 'mains'
  | 'drinks'
  | 'desserts'
  | 'deals';

export const STARTER_CATEGORIES: readonly TStarterCategory[] = [
  'starters',
  'mains',
  'drinks',
  'desserts',
  'deals',
];
